// src/routes.js
import React from 'react'
import { Router, Route } from 'react-router'
import './index.scss'

import App from './components/App'
import Domains from './components/Domains'
import Cards from './components/Cards'
import Store from './components/Store'

const Routes = (props) => (
  <Router {...props}>
    <Route path="/" component={App} />
    <Route path="/store" component={Store} />
    <Route path="/domains" component={Domains} />
    <Route path="/cards" component={Cards} />
  </Router>
)

export default Routes



// WEBPACK FOOTER //
// ./src/routes.js